module.exports = __webpack_public_path__ + "img/store_icon.bc7d46e6.png";